import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-ticket',
  templateUrl: './ticket.component.html',
  standalone: true,
  imports: [
    NgIf
  ],
  styleUrls: ['./ticket.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TicketComponent {
  @Input() ticket: any = 0;

  constructor() { }

  format(ticket:any){
    return parseFloat(ticket).toFixed(2)
  }

}
